<script>
import {
  BaseAffiliateLinkElementMixin,
} from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/base-affiliate-link-element-mixin";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";

export default {
  name: "ProductLinkPrice",
  elementPanelSettings: {
    displayName: "Price",
    displayIcon: "text-alt",
    elementType: "element",
    elementGroup: "Product",
  },
  extends: UrlElement,
  mixins: [BaseAffiliateLinkElementMixin],
  computed: {
    label() {
      return this.entity.productPrice ? `$${this.entity.productPrice}` : "";
    },
    computedHref() {
      return this.entity.affiliateLink;
    },
    shouldShowLink() {
      return !!this.label;
    },
  },
};
</script>
